import React, { useMemo, useState } from 'react'
import { useForm } from 'react-hook-form';
import Input from '../../../shared/Input';
import EditIcon from "../../../../assets/img/dashboard/edit-2.svg";
import phoneIcon from "../../../../assets/img/dashboard/call-received.svg";
import {  Radio } from "antd";
import ImageInput from '../../../shared/ImageInput';
import Textarea from '../../../shared/Textarea';
import Button from '../../../shared/Button';

const AddUsers = () => {
    const [profileInfo, setprofileInfo] = useState();
    const [profileData, setProfileData] = useState();
    const [IDCard, setIDCard] = useState();
    const [certificate, setCertificate] = useState();
    const [gender, setgender] = useState("male");
    const onChange = e => {
      setgender(e.target.value);
      console.log(gender);
    };
    const {
      handleSubmit,
      formState: { errors, isValid },
      control,
      reset
    } = useForm({
     
    });
    const onSubmit = (data)=>{
 console.log(data)
    }
  return (
    <div>
         <div className="EditProfile Admin-AddUsers">
         
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <p className="name__p">نام و نام خانوادگی</p>
            <p className="name__des">
              نام و نام خانوادگی برای سایر کاربر های جاتیک قابل مشاهده است .
            </p>
            <div className="EditProfile--grid">
              <Input
                name="first_name"
                control={control}
                errors={errors}
                className="seconadary-input "
                register={{
                  required: "  نام اجباری است"
                }}
                placeholder='نام کاربر را وارد نمایید'
                psIcon={<img src={EditIcon} />}
              />
              <Input
                name="last_name"
                control={control}
                errors={errors}
                className="seconadary-input"
                register={{
                  required: " نام خانوادگی اجباری  است"
                }}
                placeholder='نام  خانوادگی کاربر را وارد نمایید'
                psIcon={<img src={EditIcon} />}
              />
            </div>
          </div>
          <Input
            name="national_code"
            control={control}
            errors={errors}
            placeholder=" اطلاعاتی وارد نشده"
            label="کد ملی"
            className="seconadary-input my-[20px]"
            register={{
              required: "  کد ملی اجباری است"
            }}
            psIcon={<img src={EditIcon} />}
          />
          <div className="mb-[20px]">
            <p className="name__p">جنسیت شما</p>
            <Radio.Group
              //  defaultValue={createInfoData.stepTwo.gender}
              onChange={onChange}
              value={gender}
            >
              <div className="createstep2--grid">
                <div
                  className={`createsteps--radiogroupbox ${gender === "male"
                    ? "createsteps--radiogroupbox--active"
                    : ""}`}
                >
                  <Radio value="male">
                    <div className={`createsteps--radiogrouplabel`}>
                      من آقا هستم
                    </div>
                  </Radio>
                </div>
                <div
                  className={`createsteps--radiogroupbox ${gender === "female"
                    ? "createsteps--radiogroupbox--active"
                    : ""}`}
                >
                  <Radio value="female">
                    <div className="createsteps--radiogrouplabel">
                      من خانم هستم
                    </div>
                  </Radio>
                </div>
              </div>
            </Radio.Group>
          </div>
          <Input
            name="email"
            control={control}
            errors={errors}
            placeholder="آدرس ایمیل"
            label="آدرس ایمیل"
            type="email"
            className="seconadary-input mb-[20px]"
            register={{
              required: " عنوان اقامتگاه اجباری است"
            }}
            psIcon={<img src={EditIcon} />}
          />{" "}
          <Input
            LabelIcon={<img src={phoneIcon} />}
            name="phone"
            control={control}
            errors={errors}
            placeholder=" ۰۹۳۳۰۴۳۷۸۵۷"
            label="شماره تماس"
            className="seconadary-input mb-[20px]"
            register={{
              required: " عنوان اقامتگاه اجباری است"
            }}
            psIcon={<img src={EditIcon} />}
          />
         
          <div className="grid md:grid-cols-2 grid-cols-1 gap-[31px]">
            <ImageInput
              file={IDCard}
              id="3"
              setfile={setIDCard}
              text="آپلود کارت ملی"
              label="تصویر کارت ملی"
              placeholder="تصویری وارد نشده"
            />
            <ImageInput
              file={certificate}
              id="4"
              setfile={setCertificate}
              text="آپلود مجوز"
              label="فایل گردشگر خارجی"
              placeholder="تصویری وارد نشده"
            />
          </div>
          <Textarea
            name="about_me"
            control={control}
            errors={errors}
            label="معرفی مختصر من"
            className="seconadary-input mt-[50px]"
            rows="5"
          />
          <div className="flex justify-end gap-[30px] mt-[40px] Admin-AddUsers--button-row">
            <button className="red-button py-[12px] px-[32px]">انصراف </button>

            <Button varient="primary">افزودن کاربر جدید</Button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AddUsers